export const types = [
    { code: 'TIME', name: 'Цаг үеийн мэдээ', nameEng: 'Time news' },
    { code: 'VIDEO', name: 'Видео мэдээ', nameEng: 'Video news' },
    { code: 'PHOTO', name: 'Фото мэдээ', nameEng: 'Photo news' },
    // {
    //     code: 'WARNING',
    //     name: 'Газрын зөрчил арилгах арга хэмжээ',
    //     nameEng: 'Measures to remove land violations',
    // },
];
